import { Image, Page, Text, View } from "@react-pdf/renderer";
import Placeholder from "../../../../assets/placeholders/image-landscape.png";
import config from "../../../../config";
import { getNonWebpThumbnailSrc } from "../../../MediaLibrary/manageMediaLibrary";
import { styles } from "./physicalComponentPdfStyles";
import {
	PhysicalEntryRow,
	PhysicalPdfCompanyDetails,
	PhysicalPdfLabels,
} from "./types";

interface EntryManifestPageProps {
	entry: PhysicalEntryRow;
	company: PhysicalPdfCompanyDetails;
	labels: PhysicalPdfLabels;
}

const EntryManifestPage = ({
	entry,
	company,
	labels,
}: EntryManifestPageProps) => {
	const coverSrc =
		(entry.coverImage && getNonWebpThumbnailSrc(entry.coverImage)) ||
		Placeholder;

	return (
		<Page size="A4" style={styles.page}>
			<View
				style={{
					...styles.flexRow,
					...styles.justifyBetween,
					...styles.itemsCenter,
				}}
			>
				<Image style={styles.logo} src={config.assets.logos.localPng} />
				<View style={{ ...styles.flexCol, alignItems: "flex-end" }}>
					<Text style={styles.eyebrow}>{labels.physicalPdfPage3Title}</Text>
					<Text style={styles.entryNumber}>#{entry.id}</Text>
				</View>
			</View>

			{/* <View style={styles.divider} /> */}

			<View style={styles.sectionHeadingRow}>
				<Text style={styles.sectionHeading}>
					{labels.physicalPdfEntryLabel}
				</Text>
				<View style={styles.sectionRule} />
			</View>

			<View style={{ ...styles.flexRow, ...styles.justifyBetween }}>
				<View style={{ width: "65%" }}>
					<Text style={{ ...styles.labelText }}>{entry.brand}</Text>
					<Text style={{ ...styles.serifTitle, ...styles.mbHalf }}>
						{entry.title}
					</Text>

					<View style={styles.metaGrid}>
						<View style={styles.metaItem}>
							<Text style={{ ...styles.labelText, ...styles.smallestText }}>
								{labels.physicalPdfEntryIdLabel}
							</Text>
							<Text style={styles.metaValue}>{entry.id}</Text>
						</View>
						<View style={styles.metaItem}>
							<Text style={{ ...styles.labelText, ...styles.smallestText }}>
								{labels.physicalPdfTableHeaderAwardShow}
							</Text>
							<Text style={styles.metaValue}>{entry.vertical}</Text>
						</View>
						<View style={{ ...styles.metaItem }}>
							<Text style={{ ...styles.labelText, ...styles.smallestText }}>
								{labels.physicalPdfClassificationLabel}
							</Text>
							<Text style={styles.metaValue}>{entry.classification}</Text>
						</View>
					</View>
				</View>
				<Image style={styles.entryCoverImageLarge} src={coverSrc} />
			</View>

			<View style={styles.sectionHeadingRow}>
				<Text style={styles.sectionHeading}>
					{labels.physicalPdfDescriptionLabel}
				</Text>
				<View style={styles.sectionRule} />
			</View>

			<Text>{entry.physicalItemDescription}</Text>

			<View style={styles.sectionHeadingRow}>
				<Text style={styles.sectionHeading}>
					{labels.physicalPdfEntrantDetailsLabel}
				</Text>
				<View style={styles.sectionRule} />
			</View>

			<View style={{ ...styles.flexRow, ...styles.justifyBetween }}>
				<View style={{ width: "55%" }}>
					<Text style={{ ...styles.serifTitle, ...styles.mbHalf }}>
						{company.entryContactName}
					</Text>
					<Text style={styles.bodyText}>{company.companyName}</Text>
					<Text style={styles.bodyText}>{company.companyAddress1}</Text>
					{company.companyAddress2 ? (
						<Text style={styles.bodyText}>{company.companyAddress2}</Text>
					) : null}
					<Text style={styles.bodyText}>
						{company.companyCity}
						{company.companyState ? `, ${company.companyState}` : ""}{" "}
						{company.companyPostalCode}
					</Text>
					<Text style={styles.bodyText}>{company.companyCountry}</Text>
				</View>
				<View>
					<Text
						style={{
							...styles.labelText,
							...styles.mbHalf,
							...styles.smallestText,
						}}
					>
						{labels.physicalPdfContactLabel}
					</Text>
					<Text style={styles.bodyText}>{company.entryContactPhone}</Text>
					<Text style={styles.bodyText}>{company.entryContactEmail}</Text>
				</View>
			</View>

			<View style={styles.mt1}>
				<View style={styles.sectionHeadingRow}>
					<Text style={styles.sectionHeading}>
						{labels.physicalPdfAdminTitle}
					</Text>
					<View style={styles.sectionRule} />
				</View>

				<Text
					style={{
						...styles.bodyText,
						...styles.mutedText,
						...styles.mbHalf,
					}}
				>
					{labels.physicalPdfAdminDoNotCut}
				</Text>

				<View style={{ ...styles.adminBox, ...styles.mt1 }}>
					<View style={{ width: "65%" }}>
						<Text style={{ ...styles.labelText }}>{entry.brand}</Text>
						<Text style={{ ...styles.serifTitle, ...styles.mb1 }}>
							{entry.title}
						</Text>
						<Text style={{ ...styles.bodyText, fontWeight: 700 }}>
							{labels.physicalPdfEntryIdLabel}: {entry.id}
						</Text>
						<Text style={styles.bodyText}>{entry.classification}</Text>
					</View>
					<View style={{ ...styles.flexCol, alignItems: "flex-end" }}>
						<Image
							style={{ ...styles.entryCoverImg, ...styles.mbHalf }}
							src={coverSrc}
						/>
						{entry.qrCodeUrl ? (
							<Image style={styles.qrCode} src={entry.qrCodeUrl} />
						) : null}
					</View>
				</View>
			</View>
		</Page>
	);
};

export default EntryManifestPage;
